import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = ['Home', 'Eat', 'Drink', 'Nightlife', 'Gallery'];
  const getPath = (link: string) => link === 'Home' ? '/' : `/${link.toLowerCase()}`;
  const isActive = (link: string) => location.pathname === getPath(link);
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 px-6 md:px-8 py-4 md:py-6 ${isScrolled || isMobileMenuOpen ? 'bg-obsidian/95 backdrop-blur-md border-b border-champagne/10' : 'bg-transparent'}`} data-id="element-135">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-136">
        <Link to="/" className="z-50 flex items-center font-serif text-xl md:text-2xl tracking-widest" data-id="element-137">
          <span className="text-crimson text-4xl" data-id="element-138">D</span>
          <span className="text-champagne border border-champagne px-2 py-1 leading-none flex items-center justify-center" data-id="element-139">
            14
          </span>
        </Link>

        {/* Desktop Links */}
        <div className="hidden md:flex space-x-12" data-id="element-140">
          {navLinks.map(link => {
          const active = isActive(link);
          return <Link key={link} to={getPath(link)} className={`text-sm uppercase tracking-[0.3em] font-serif transition-colors duration-300 relative ${active ? 'text-champagne' : 'text-white/80 hover:text-champagne'}`} data-id="element-141">
                {link}
                {active && <motion.div layoutId="activeNavIndicator" className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-1 h-1 bg-champagne rounded-full" transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30
            }} data-id="element-142" />}
              </Link>;
        })}
        </div>

        {/* Desktop CTA */}
        <div className="hidden md:block" data-id="element-143">
          <Link to="/booking" className="inline-block text-sm uppercase tracking-[0.3em] font-serif bg-crimson text-white px-8 py-3 hover:bg-white hover:text-crimson transition-all duration-500 shadow-[0_0_15px_rgba(219,32,39,0.4)]" data-id="element-144">
            Book Now
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-champagne z-50" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-145">
          {isMobileMenuOpen ? <X size={24} data-id="element-146" /> : <Menu size={24} data-id="element-147" />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-148">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: '100vh'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="fixed inset-0 bg-obsidian z-40 flex flex-col items-center justify-center space-y-8 md:hidden" data-id="element-149">
            {navLinks.map(link => {
          const active = isActive(link);
          return <Link key={link} to={getPath(link)} onClick={() => setIsMobileMenuOpen(false)} className={`text-2xl uppercase tracking-[0.4em] font-serif transition-colors relative ${active ? 'text-champagne' : 'text-white hover:text-champagne'}`} data-id="element-150">
                  {link}
                  {active && <motion.div layoutId="activeNavIndicatorMobile" className="absolute -bottom-3 left-1/2 -translate-x-1/2 w-1.5 h-1.5 bg-champagne rounded-full" data-id="element-151" />}
                </Link>;
        })}

            <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="mt-8 pt-8 border-t border-white/10 w-full max-w-xs flex justify-center" data-id="element-152">
              <Link to="/booking" onClick={() => setIsMobileMenuOpen(false)} className="w-full text-center text-sm uppercase tracking-[0.3em] font-serif bg-crimson text-white py-4 shadow-[0_0_15px_rgba(219,32,39,0.4)]" data-id="element-153">
                Book Now
              </Link>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
}